@if (message) {
    <div class="betslip-onboarding-content">
        @if (message.onboardingImageUrl) {
            <img src="{{ message.onboardingImageUrl }}" class="onboarding-image" />
        }
        <div class="onboarding-header">{{ message.onboardingHeader }}</div>
        <div class="onboarding-body" [innerHTML]="message.onboardingBody"></div>
        <div class="onboarding-footer" [innerHTML]="message.onboardingFooter"></div>
    </div>
}
